# ------------------------------------*|
#     #Editor NameSpace elements
# ------------------------------------*|

EditorNamespace = angular.module 'services.editorNamespace', []

EditorNamespace.factory 'ns', ["$timeout", "$state", ($timeout, $state) ->

  namespace =
    blockClass: ".str-block"
    blockDropOverlay: ".str-dropoverlay"
    blockOverlay: ".widget-overlay"
    blockTextClass: ".str-bw_text"
    blockHeadline1Class: ".str-bw_headline_h1"
    blockHeadline2Class: ".str-bw_headline_h2"
    blockHeadline3Class: ".str-bw_headline_h3"
    blockMenuClass: ".et-block-list"
    blockMenuClassShow: "etbl__show"
    blockSettingsEditing: ".block__settings-editing"
    blockSettingsEditing_noshadow: "block__settings-editing_noshadow"
    blockLoader: '<div class="cubes-block__loader">
        <div class="csl-cube cube1"></div>
        <div class="csl-cube cube2"></div>
        <div class="csl-cube cube3"></div>
        <div class="csl-cube cube4"></div>
      </div>'
    sectionLoader: '<div class="cubes-section__loader">
        <div class="csl-cube csl-cube_section cube1"></div>
        <div class="csl-cube csl-cube_section cube2"></div>
        <div class="csl-cube csl-cube_section cube3"></div>
        <div class="csl-cube csl-cube_section cube4"></div>
      </div>'
    colClass: ".str-col"
    dropBackdropClass: ".str-drop-backdrop"
    dropHeaderClass: ".e-header__area"
    dropFooterClass: ".e-footer__area"
    dropBackdropDragoverClass: ".str-drop-backdrop-dragover"
    dragBlockToRowDistance: 10
    dragBlockToColInColDistance: 10
    dragPanelClass: ".et__drag-panel-wrapper"
    dragPanelTable: ".et__drag-panel-table"
    dragPanelWidgetClass: ".et__drag-panel-wrapper_widget"
    dragPanelSectionClass: ".et__drag-panel-wrapper_section"
    dragPanelRemoveButton: ".etdp__button_remove"
    dragOverLineWidth: 2
    editBlockButtonClass: ".etdp__button"
    floatingClass: "str-floating"
    sliderClass: "strw-slider"
    sliderSlideClass: "strw-slider__image_cover"
    helperClass: "str-helper"
    insertPointClass: "str-insert-point"
    insertSpaceClassHelper: "etbl__link"
    insertSpaceClass: "str-insert-space"
    insertSpaceNode: "<div class='str-insert-space'></div>"
    spacerClass: "str-bw_spacer"
    spacerContentClass: "str-bw_spacer-content"
    spacerWrapperClass: "yui3-resize-handles-wrapper"
    shiftTop: -> return 0
    tplContainer: "#tpl-wrapper"
    menuBlockClass: ".etbl-block"
    maxColumns: 12
    modulesSettingsModal: "modules_settings-modal"
    resizerClass: "str-helper__resizer"
    resizerLineClass: "str-helper--resizer__line"
    rowClass: ".str-row"
    sectionClass: ".str-section"
    settingsWindowClass: ".et-settings-panel"
    # settingsWindowHead: ".etsw-header"
    sectionDraggingClass: "str-section_dragging"
    widgetWrapperClass: ".widget-wrapper"
    widgetLineContentClass: ".str-bw_line-content"
    widgetFormButtonWrapperClass: ".strwf__form-button__wrapper"
    widgetFormParentButtonWrapperClass: ".strwf__parent-button__wrapper"
    widgetLineClass: ".strwf__line-wrapper"
    widgetButtonClass: ".strwf_button"
    widgetButtonTwoClass: ".strwf_button-two"
    widgetVideoClass: ".strwvideo"
    wrapperClass: ".str-wrapper"
  namespace
]



// WEBPACK FOOTER //
// ./src/app/editor/services/editorNamespace.coffee